import * as Yup from "yup";

export const initialValues = {
  leaveTypeId: null,
  remainingLeave: null,
  durationType: "ALLDAY",
  leaveDate: null,
  endLeaveDate: null,
  startTime: "00:00:00",
  endTime: "00:00:00",
  description: null,
};

const LeaveSchema = Yup.object().shape({
  leaveTypeId: Yup.string().required("Please select."),
  // remainingLeave: Yup.string().required("Please enter."),
  // leaveDate: Yup.string().required("Please select."),
  // endLeaveDate: Yup.string().required("Please select."),
  description: Yup.string().required("Please enter."),
});

export default LeaveSchema;
